import { ColumnDef } from '@tanstack/react-table';

import { formatDateInTable } from 'features/global/utils/datetimes';
import { Option } from 'features/global/utils/globalOptions';

export const sanitaryMeasuresColumns: ColumnDef<any>[] = [
  { header: 'Port name', accessorKey: 'portName' },
  { header: 'UNLOCODE', accessorKey: 'unlocode' },
  { header: 'Type of sanitary measure', accessorKey: 'typeOfSanitaryMeasure' },
  {
    header: 'Date from',
    accessorKey: 'dateFrom',
    cell: ({ getValue }) => formatDateInTable({ value: getValue() }),
  },
  {
    header: 'Date to',
    accessorKey: 'dateTo',
    cell: ({ getValue }) => formatDateInTable({ value: getValue() }),
  },
];

export const lastPortInThirtyDaysColumns: ColumnDef<any>[] = [
  { header: 'Port name', accessorKey: 'name', id: 'name' },
  { header: 'UNLOCODE', accessorKey: 'unlocode', id: 'unlocode' },
  {
    header: 'Date from',
    accessorKey: 'dateFrom',
    id: 'dateFrom',
    cell: ({ getValue }) => formatDateInTable({ value: getValue() }),
  },
  {
    header: 'Date to',
    accessorKey: 'dateTo',
    id: 'dateTo',
    cell: ({ getValue }) => formatDateInTable({ value: getValue() }),
  },
];

export const stateParticularColumns: ColumnDef<any>[] = [
  { header: 'Family name', accessorKey: 'familyName', id: 'familyName' },
  { header: 'Given names', accessorKey: 'givenNames', id: 'givenNames' },
  {
    header: 'Class or rating',
    accessorKey: 'classOrRating',
    id: 'classOrRating',
  },
  { header: 'Gender', accessorKey: 'gender', id: 'gender' },
  { header: 'Nationality', accessorKey: 'nationality', id: 'nationality' },
  {
    header: 'Port of embarkation',
    accessorKey: 'portOfEmbarkation',
    id: 'portOfEmbarkation',
  },
  {
    header: 'Date of embarkation',
    accessorKey: 'dateOfEmbarkation',
    id: 'dateOfEmbarkation',
    cell: ({ getValue }) => formatDateInTable({ value: getValue() }),
  },
  {
    header: 'Nature of illness',
    accessorKey: 'natureOfIllness',
    id: 'natureOfIllness',
  },
  {
    header: 'Date of onset of symptoms',
    accessorKey: 'dateOfOnsetOfSymptoms',
    id: 'dateOfOnsetOfSymptoms',
    cell: ({ getValue }) => formatDateInTable({ value: getValue() }),
  },
  {
    header: 'Reported to a port medical officer',
    accessorKey: 'reportedToPortMedicalOfficer',
    id: 'reportedToPortMedicalOfficer',
  },
  { header: 'State', accessorKey: 'state', id: 'state' },
  {
    header: 'Disposal of case *',
    accessorKey: 'disposalOfCase',
    id: 'disposalOfCase',
  },
  {
    header: 'Port evacuated',
    accessorKey: 'evacuatedAtPort',
    id: 'evacuatedAtPort',
  },
  {
    header: 'Treatment given (drug medicines or other)',
    accessorKey: 'treatmentGiven',
    id: 'treatmentGiven',
  },
  { header: 'Comments', accessorKey: 'comments', id: 'comments' },
];

export const sanitaryMeasureTypes: Option[] = [
  { value: 'Quarantine', label: 'Quarentine' },
  { value: 'Isolation', label: 'Isolation' },
  { value: 'Disinfection', label: 'Disinfection' },
  { value: 'Decontamination', label: 'Decontamination' },
];

export const particularStates: Option[] = [
  { value: 'Recovered', label: 'Recovered' },
  { value: 'Ill', label: 'Ill' },
  { value: 'Died', label: 'Died' },
];

export const caseDisposals: Option[] = [
  { value: 'On board', label: 'On board' },
  { value: 'Evacuated', label: 'Evacuated' },
  { value: 'Buried at sea', label: 'Buried at sea' },
];
